module.exports = function() {
  return new Worker(__webpack_public_path__ + "579d37b2e5a17353a895.worker.js");
};